// Module
var code = "<template>\n    <div show.bind=\"visible\">\n        <slot></slot>\n    </div>\n</template>\n";
// Exports
export default code;